var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"loginCard",attrs:{"rounded":"","min-width":"450px","color":"white","elevation":"12px"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }